import { render, staticRenderFns } from "./RelatorioIndividual.vue?vue&type=template&id=67f8dbb1&scoped=true&"
import script from "./RelatorioIndividual.vue?vue&type=script&lang=js&"
export * from "./RelatorioIndividual.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioIndividual.vue?vue&type=style&index=0&id=67f8dbb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f8dbb1",
  null
  
)

export default component.exports